<template>
  <section class="section">
    <h1 class="title">
      <a @click="$router.go(-1)">
        <b-icon icon="arrow-left" />
      </a>
    </h1>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <div class="columns">
      <div class="column is-three-quarters">
        <user-form
          @formSubmit="callPutUpdateUser"
          v-if="userData"
          :userData="userData"
          mode="update"
        />
      </div>
      <div class="column">
        <h2 class="title">{{ $t('Solicitudes') }}</h2>
        <ul>
          <li v-for="request in userRequests" :key="request.GSI1SK">
            <a @click="goToRequestDetail(request.GSI1SK)">{{
              request.email
            }}</a>
            -
            {{ request.updatedAt | formatTimestampShort }}
          </li>
        </ul>
        <h2 class="title">{{ $t('Subpartners') }}</h2>
        <ul>
          <li v-for="user in userSubUsers" :key="user.GSI1SK">
            <router-link
              :to="{
                name: 'admin.users.update',
                params: { id: user.user_id }
              }"
            >
              {{ user.PK }}</router-link
            >
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import UserForm from '@/components/admin/users/UserForm'

import Fetcher from '@/mixins/fetcher.js'
import { mapActions } from 'vuex'

export default {
  mixins: [Fetcher],
  components: { UserForm },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      userRequests: [],
      userSubUsers: [],
      userData: {
        firstName: null,
        lastName: null,
        profession: null,
        city: null,
        telephone: null,
        country: null,
        socialNetwork: null,
        contactEmail: null,
        email: null,
        deposit: false,
        admissionsComittee: false,
        kycInformation: false,
        ndaDraft: false,
        contractDraft: false,
        kyc: null,
        subscription: null,
        signedNDA: null,
        admissionDate: null,
        signedContract: null
      }
    }
  },
  watch: {
    $route(to, from) {
      this.getData()
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('user', [
      'getUserDetails',
      'putUpdateUser',
      'getUserRequests',
      'getUserSubUsers'
    ]),
    getData() {
      this.callGetUserDetails()
      this.callGetUserRequests()
      this.callGetUserSubUsers()
    },
    goToRequestDetail(id) {
      this.$router.push({ name: 'admin.on-board.detail', params: { id: id } })
    },
    callPutUpdateUser(userData) {
      let self = this
      self.request(() =>
        self
          .putUpdateUser({ userId: self.id, data: { userData } })
          .then(function() {
            self.$toast.open({
              message: self.$t('Actualizado!'),
              type: 'success'
            })
          })
      )
    },
    callGetUserSubUsers() {
      let self = this
      self.request(() =>
        self.getUserSubUsers(self.id).then(function(response) {
          self.userSubUsers = response.data
        })
      )
    },
    callGetUserRequests() {
      let self = this
      self.request(() =>
        self.getUserRequests(self.id).then(function(response) {
          self.userRequests = response.data
        })
      )
    },
    callGetUserDetails() {
      let self = this
      self.request(() =>
        self.getUserDetails(self.id).then(function(response) {
          Object.entries(self.keysToCamel(response.data)).forEach(function(
            entry
          ) {
            self.userData[entry[0]] = entry[1]
          })
        })
      )
    }
  }
}
</script>

<style></style>
